import { z } from 'zod';
import { expectType } from './model.js';
import { EmptyPostBase, zFullPostBase, zPostBase } from './post.js';
export const BUSINESS_CHECKIN_TOPIC = 'business-checkin';
export const zBusinessCheckInFields = z.object({
    postType: z.literal('businessCheckIn'),
    businessId: z.string()
});
export const zBusinessCheckIn = zPostBase.merge(zBusinessCheckInFields);
expectType({});
expectType({});
export const zFullBusinessCheckIn = zFullPostBase.merge(zBusinessCheckInFields);
expectType({});
expectType({});
export const EmptyBusinessCheckIn = {
    ...EmptyPostBase,
    postType: 'businessCheckIn',
    businessId: ''
};
